import React, { useEffect, useState } from "react";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import { useTranslation } from "react-i18next";
import { ROUTE } from "../../route/Route";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import SeoAdd from "../Seo/SeoAdd";
import { dashboardAction, submitAction, testAction } from "../../redux/action";
import SitemapIcon from "./SitemapIcon";

const Sitemap = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [limit, setLimit] = useState(5000);
  const [offsetT, setOffsetT] = useState(0);
  const [subCategory, setSubCategory] = useState(100);
  const cityData = useSelector((state: any) => state.dashboard.cityAll);
  const testData = useSelector((state: any) => state.test.list?.Tests);
  const [showAllCityItems, setShowAllCityItems] = useState(false);
  const [showAllTestItems, setShowAllTestItems] = useState(false);
  useEffect(() => {
    window?.scrollTo(0, 0);
    dispatch(testAction.listTestAction({ Offset: offsetT, Limit: limit }));
    return () => {};
  }, []);

  const toggleShowAllCityItems = () => {
    setShowAllCityItems(!showAllCityItems);
  };

  const toggleShowAllTestItems = () => {
    setShowAllTestItems(!showAllTestItems);
  };

  return (
    <>
      <SeoAdd slug={ROUTE.SITEMAP} />
      <div className="content pb-0 pt-0 bg-gray">
        <BreadCrumb page={t("sitemap")} data={{ slug: "", path: "" }} />
        <section className="about-section">
          <div className="container sitemap-container">
            <div className="row mt-3">
              <div className="col-md-4 mb-3 ng-star-inserted">
                <div className="sitemap-col">
                  <ul>
                    <li className="site-map-label">
                      <SitemapIcon />{" "}
                      Home
                    </li>
                  </ul>
                </div>
                <ul className="sitemap-links">
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/">Home</a>
                  </li>
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/overview">About Us</a>
                  </li>
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/directors-message">
                      Director's Message
                    </a>
                  </li>
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/endeavour">
                      Vision/Mission/Values
                    </a>
                  </li>
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/accreditation">
                      Accreditations
                    </a>
                  </li>
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/award-recognition">
                      Awards
                    </a>
                  </li>
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/centres">Our Network</a>
                  </li>
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/news-updates">
                      Event/CME/Press Release
                    </a>
                  </li>
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/blog/">Blog</a>
                  </li>
                </ul>
              </div>
              <div className="col-md-4 mb-3 ng-star-inserted">
                <div className="sitemap-col">
                  <ul>
                    <li className="site-map-label">
                    <SitemapIcon />{" "}
                      Patient
                    </li>
                  </ul>
                </div>
                <ul className="sitemap-links">
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/book-a-test">
                      Book a Test
                    </a>
                  </li>
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/offers">
                      Offers and Discounts
                    </a>
                  </li>
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/home-collection">
                      Home Collection
                    </a>
                  </li>
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/testimonials">
                      Testimonials
                    </a>
                  </li>
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/faq">FAQ's</a>
                  </li>
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/quick-links">
                      Quick Link's
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-md-4 mb-3 ng-star-inserted">
                <div className="sitemap-col">
                  <ul>
                    <li className="site-map-label">
                    <SitemapIcon />{" "}
                      Doctors
                    </li>
                  </ul>
                </div>
                <ul className="sitemap-links">
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/departments">
                      Department
                    </a>
                  </li>
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/brochures">Brochures</a>
                  </li>
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/testimonials">
                      Testimonial
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-md-4 mb-3 ng-star-inserted">
                <div className="sitemap-col">
                  <ul>
                    <li className="site-map-label">
                    <SitemapIcon />{" "}
                    Connect Us
                    </li>
                  </ul>
                </div>
                <ul className="sitemap-links">
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/corporate-office">
                    Corporate Office
                    </a>
                  </li>
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/general-enquiry">General Enquiry</a>
                  </li>
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/corporate">
                    Corporate Wellness
                    </a>
                  </li>
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/career">
                    Career
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-md-4 mb-3 ng-star-inserted">
                <div className="sitemap-col">
                  <ul>
                    <li className="site-map-label">
                    <SitemapIcon />{" "}
                    Partner With Us
                    </li>
                  </ul>
                </div>
                <ul className="sitemap-links">
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/partner-with-us">
                    Become a Partner
                    </a>
                  </li>
                  <li className="readmorekl0">
                    <a href="https://oncquestlabs.com/clinical-trial">Clinical Trial</a>
                  </li>
                </ul>
              </div>
              <div className="col-md-4 mb-3 ng-star-inserted">
                <div className="sitemap-col">
                  <ul>
                    <li className="site-map-label">
                    <SitemapIcon />{" "}
                      Other Logins
                    </li>
                  </ul>
                </div>
                <ul className="sitemap-links">
                  <li className="readmorekl0">
                    <a href="https://itd.oncquest.net/Oncquest/Design/onlinelab/">
                    Panel Report  
                    </a>
                  </li>
                  <li className="readmorekl0">
                    <a href="https://admin.oncquestlabs.com/search-tests">Test Range</a>
                  </li>
                </ul>
            </div>
              <div className="col-md-12 mt-3 mb-3 ng-star-inserted">
                <div className="sitemap-col">
                  <ul>
                    <li className="site-map-label">
                    <SitemapIcon />{" "}
                      Book a Test
                    </li>
                  </ul>
                </div>
                <ul className="sitemap-test-url">
                  {cityData &&
                    cityData?.length > 0 &&
                    cityData
                      .slice(0, showAllCityItems ? cityData.length : 10)
                      .map((item: any, i: any) => (
                        <li className="readmorekl0" key={i}>
                          <Link
                            to={`${ROUTE.PATHLOGYTEST}/${t(
                              item?.Name
                            ).toLowerCase()}`}
                          >
                            Lab Test in {t(item?.Name)}
                          </Link>
                        </li>
                      ))}
                </ul>
                {cityData && cityData?.length > 10 && (
                  <button
                    className="sitemap-read-more"
                    onClick={toggleShowAllCityItems}
                  >
                    {showAllCityItems ? "Read Less" : "Read More"}
                  </button>
                )}
              </div>
              <div className="col-md-12 mt-3 mb-3 ng-star-inserted">
                <div className="sitemap-col">
                  <ul>
                    <li className="site-map-label">
                    <SitemapIcon />{" "}
                      Pathology Test
                    </li>
                  </ul>
                </div>
                <ul className="sitemap-test-url">
                  {testData &&
                    testData?.length > 0 &&
                    testData
                      .slice(0, showAllTestItems ? testData.length : 10)
                      .map((item: any, i: any) => (
                        <li className="readmorekl0" key={i}>
                          <Link
                            to={`${ROUTE.TESTDETAILS}/${t(
                              item?.Slug
                            ).toLowerCase()}`}
                          >
                            {t(item?.TestName)}
                          </Link>
                        </li>
                      ))}
                </ul>
                {testData && testData?.length > 10 && (
                  <button
                    className="sitemap-read-more"
                    onClick={toggleShowAllTestItems}
                  >
                    {showAllTestItems ? "Read Less" : "Read More"}
                  </button>
                )}
              </div>
              </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Sitemap;
